var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86022 9.00004L0.442553 2.58237C-0.148201 1.99162 -0.148201 1.03382 0.442553 0.44315C1.03331 -0.147604 1.99102 -0.147604 2.58178 0.44315L8.99953 6.8609L15.4173 0.443066C16.008 -0.147689 16.9658 -0.147689 17.5565 0.443066C18.1472 1.03382 18.1472 1.99162 17.5565 2.58229L11.1388 8.99996L17.5565 15.4177C18.1472 16.0085 18.1472 16.9663 17.5565 17.5569C16.9658 18.1477 16.008 18.1477 15.4173 17.5569L8.99953 11.1392L2.58178 17.5569C1.99111 18.1477 1.03331 18.1477 0.442553 17.5569C-0.148201 16.9662 -0.148201 16.0085 0.442553 15.4177L6.86022 9.00004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c6f0df2d101edd078ea5be2427335375.svg";
export { ForwardRef as ReactComponent };